"use strict";
export const loginRequest = validate11;
const schema12 = { "$id": "#/definitions/loginRequest", "type": "object", "additionalProperties": false, "properties": { "email": { "type": "string", "minLength": 1 }, "password": { "type": "string", "minLength": 1 }, "token": { "type": "string", "minLength": 1 }, "tan": { "type": "string", "minLength": 1 } }, "required": ["email", "password"] };
import __req_func2 from "ajv/dist/runtime/ucs2length.js";
const func2 = __req_func2.default;
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/loginRequest" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.email === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "email" }, message: "must have required property '" + "email" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.password === undefined) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "password" }, message: "must have required property '" + "password" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!((((key0 === "email") || (key0 === "password")) || (key0 === "token")) || (key0 === "tan"))) {
                const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.email !== undefined) {
            let data0 = data.email;
            if (typeof data0 === "string") {
                if (func2(data0) < 1) {
                    const err3 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            else {
                const err4 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.password !== undefined) {
            let data1 = data.password;
            if (typeof data1 === "string") {
                if (func2(data1) < 1) {
                    const err5 = { instancePath: instancePath + "/password", schemaPath: "#/properties/password/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            else {
                const err6 = { instancePath: instancePath + "/password", schemaPath: "#/properties/password/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
        }
        if (data.token !== undefined) {
            let data2 = data.token;
            if (typeof data2 === "string") {
                if (func2(data2) < 1) {
                    const err7 = { instancePath: instancePath + "/token", schemaPath: "#/properties/token/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            else {
                const err8 = { instancePath: instancePath + "/token", schemaPath: "#/properties/token/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
        }
        if (data.tan !== undefined) {
            let data3 = data.tan;
            if (typeof data3 === "string") {
                if (func2(data3) < 1) {
                    const err9 = { instancePath: instancePath + "/tan", schemaPath: "#/properties/tan/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
            else {
                const err10 = { instancePath: instancePath + "/tan", schemaPath: "#/properties/tan/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
    }
    else {
        const err11 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err11];
        }
        else {
            vErrors.push(err11);
        }
        errors++;
    }
    validate11.errors = vErrors;
    return errors === 0;
}
export const loginResponse = validate12;
const schema13 = { "$id": "#/definitions/loginResponse", "oneOf": [{ "type": "object", "additionalProperties": false, "properties": { "status": { "const": "success" }, "user": { "type": "object", "additionalProperties": false, "properties": { "id": { "type": "string" }, "permissions": { "type": "array", "items": { "type": "string", "enum": ["customer.create.all", "customer.edit.all", "customer.edit.customer", "staff.deactivate.all", "staff.deactivate.customer", "user.create.admin.all", "user.create.admin.customer", "user.create.customeradmin.all", "user.create.customeradmin.customer", "user.create.therapist.all", "user.create.therapist.customer", "user.create.assistant.all", "user.create.assistant.customer", "user.create.therapistdrs.all", "user.create.therapistdrs.customer", "user.edit.registered.all", "user.edit.registered.customer", "user.edit.registered.own", "user.edit.admin.all", "user.edit.admin.customer", "user.edit.admin.own", "user.edit.customeradmin.all", "user.edit.customeradmin.customer", "user.edit.customeradmin.own", "user.edit.therapist.all", "user.edit.therapist.customer", "user.edit.therapist.own", "user.edit.assistant.all", "user.edit.assistant.customer", "user.edit.assistant.own", "user.edit.therapistdrs.all", "user.edit.therapistdrs.customer", "user.edit.therapistdrs.own", "user.delete.admin.all", "user.delete.admin.customer", "user.delete.customeradmin.all", "user.delete.customeradmin.customer", "user.delete.therapist.all", "user.delete.therapist.customer", "user.delete.assistant.all", "user.delete.assistant.customer", "user.delete.therapistdrs.all", "user.delete.therapistdrs.customer", "user.edit-billing-approval.all", "user.edit-billing-approval.customer", "user.edit-billing-approval.own", "user.see.own.all", "user.see.client.customer", "user.see.specialist.all", "user.see.specialist.customer", "appointment.see.customer", "appointment.see.specialist-own", "appointment.see.public", "appointment.edit.customer", "appointment.edit.specialist-own", "appointment.bill.allowed", "medicalfeeschedule.edit.customer", "medicalfeeschedule.edit.specialist-own", "patientrecord.edit.customer", "patientrecord.download.customer", "patientrecord.download.specialist-own", "medicalhistory.edit.specialist-own", "videochat.join.customer", "videochat.join.specialist-own", "invoice.create.customer", "invoice.create.specialist-own", "invoice.manage.customer", "invoice.manage.specialist-own", "invoice.delete.customer", "invoice.delete.specialist-own", "appointmenttype.edit.customer", "appointmenttype.edit.specialist-own", "mollie.onboarding.customer"] } } }, "required": ["id", "permissions"] } }, "required": ["status", "user"] }, { "type": "object", "additionalProperties": false, "properties": { "status": { "const": "tan required" }, "token": { "type": "string", "minLength": 1 } }, "required": ["status", "token"] }, { "type": "object", "additionalProperties": false, "properties": { "status": { "const": "error" }, "error": { "type": "string", "enum": ["invalid credentials", "invalid tan", "account locked", "need verification"] } }, "required": ["status", "error"] }] };
function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/loginResponse" */ ;
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.status === undefined) {
            const err0 = { instancePath, schemaPath: "#/oneOf/0/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.user === undefined) {
            const err1 = { instancePath, schemaPath: "#/oneOf/0/required", keyword: "required", params: { missingProperty: "user" }, message: "must have required property '" + "user" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!((key0 === "status") || (key0 === "user"))) {
                const err2 = { instancePath, schemaPath: "#/oneOf/0/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.status !== undefined) {
            if ("success" !== data.status) {
                const err3 = { instancePath: instancePath + "/status", schemaPath: "#/oneOf/0/properties/status/const", keyword: "const", params: { allowedValue: "success" }, message: "must be equal to constant" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.user !== undefined) {
            let data1 = data.user;
            if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                if (data1.id === undefined) {
                    const err4 = { instancePath: instancePath + "/user", schemaPath: "#/oneOf/0/properties/user/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                if (data1.permissions === undefined) {
                    const err5 = { instancePath: instancePath + "/user", schemaPath: "#/oneOf/0/properties/user/required", keyword: "required", params: { missingProperty: "permissions" }, message: "must have required property '" + "permissions" + "'" };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                for (const key1 in data1) {
                    if (!((key1 === "id") || (key1 === "permissions"))) {
                        const err6 = { instancePath: instancePath + "/user", schemaPath: "#/oneOf/0/properties/user/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                }
                if (data1.id !== undefined) {
                    if (typeof data1.id !== "string") {
                        const err7 = { instancePath: instancePath + "/user/id", schemaPath: "#/oneOf/0/properties/user/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                }
                if (data1.permissions !== undefined) {
                    let data3 = data1.permissions;
                    if (Array.isArray(data3)) {
                        const len0 = data3.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                            let data4 = data3[i0];
                            if (typeof data4 !== "string") {
                                const err8 = { instancePath: instancePath + "/user/permissions/" + i0, schemaPath: "#/oneOf/0/properties/user/properties/permissions/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (!(((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((data4 === "customer.create.all") || (data4 === "customer.edit.all")) || (data4 === "customer.edit.customer")) || (data4 === "staff.deactivate.all")) || (data4 === "staff.deactivate.customer")) || (data4 === "user.create.admin.all")) || (data4 === "user.create.admin.customer")) || (data4 === "user.create.customeradmin.all")) || (data4 === "user.create.customeradmin.customer")) || (data4 === "user.create.therapist.all")) || (data4 === "user.create.therapist.customer")) || (data4 === "user.create.assistant.all")) || (data4 === "user.create.assistant.customer")) || (data4 === "user.create.therapistdrs.all")) || (data4 === "user.create.therapistdrs.customer")) || (data4 === "user.edit.registered.all")) || (data4 === "user.edit.registered.customer")) || (data4 === "user.edit.registered.own")) || (data4 === "user.edit.admin.all")) || (data4 === "user.edit.admin.customer")) || (data4 === "user.edit.admin.own")) || (data4 === "user.edit.customeradmin.all")) || (data4 === "user.edit.customeradmin.customer")) || (data4 === "user.edit.customeradmin.own")) || (data4 === "user.edit.therapist.all")) || (data4 === "user.edit.therapist.customer")) || (data4 === "user.edit.therapist.own")) || (data4 === "user.edit.assistant.all")) || (data4 === "user.edit.assistant.customer")) || (data4 === "user.edit.assistant.own")) || (data4 === "user.edit.therapistdrs.all")) || (data4 === "user.edit.therapistdrs.customer")) || (data4 === "user.edit.therapistdrs.own")) || (data4 === "user.delete.admin.all")) || (data4 === "user.delete.admin.customer")) || (data4 === "user.delete.customeradmin.all")) || (data4 === "user.delete.customeradmin.customer")) || (data4 === "user.delete.therapist.all")) || (data4 === "user.delete.therapist.customer")) || (data4 === "user.delete.assistant.all")) || (data4 === "user.delete.assistant.customer")) || (data4 === "user.delete.therapistdrs.all")) || (data4 === "user.delete.therapistdrs.customer")) || (data4 === "user.edit-billing-approval.all")) || (data4 === "user.edit-billing-approval.customer")) || (data4 === "user.edit-billing-approval.own")) || (data4 === "user.see.own.all")) || (data4 === "user.see.client.customer")) || (data4 === "user.see.specialist.all")) || (data4 === "user.see.specialist.customer")) || (data4 === "appointment.see.customer")) || (data4 === "appointment.see.specialist-own")) || (data4 === "appointment.see.public")) || (data4 === "appointment.edit.customer")) || (data4 === "appointment.edit.specialist-own")) || (data4 === "appointment.bill.allowed")) || (data4 === "medicalfeeschedule.edit.customer")) || (data4 === "medicalfeeschedule.edit.specialist-own")) || (data4 === "patientrecord.edit.customer")) || (data4 === "patientrecord.download.customer")) || (data4 === "patientrecord.download.specialist-own")) || (data4 === "medicalhistory.edit.specialist-own")) || (data4 === "videochat.join.customer")) || (data4 === "videochat.join.specialist-own")) || (data4 === "invoice.create.customer")) || (data4 === "invoice.create.specialist-own")) || (data4 === "invoice.manage.customer")) || (data4 === "invoice.manage.specialist-own")) || (data4 === "invoice.delete.customer")) || (data4 === "invoice.delete.specialist-own")) || (data4 === "appointmenttype.edit.customer")) || (data4 === "appointmenttype.edit.specialist-own")) || (data4 === "mollie.onboarding.customer"))) {
                                const err9 = { instancePath: instancePath + "/user/permissions/" + i0, schemaPath: "#/oneOf/0/properties/user/properties/permissions/items/enum", keyword: "enum", params: { allowedValues: schema13.oneOf[0].properties.user.properties.permissions.items.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err10 = { instancePath: instancePath + "/user/permissions", schemaPath: "#/oneOf/0/properties/user/properties/permissions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err11 = { instancePath: instancePath + "/user", schemaPath: "#/oneOf/0/properties/user/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
    }
    else {
        const err12 = { instancePath, schemaPath: "#/oneOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err12];
        }
        else {
            vErrors.push(err12);
        }
        errors++;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs14 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.status === undefined) {
            const err13 = { instancePath, schemaPath: "#/oneOf/1/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
            if (vErrors === null) {
                vErrors = [err13];
            }
            else {
                vErrors.push(err13);
            }
            errors++;
        }
        if (data.token === undefined) {
            const err14 = { instancePath, schemaPath: "#/oneOf/1/required", keyword: "required", params: { missingProperty: "token" }, message: "must have required property '" + "token" + "'" };
            if (vErrors === null) {
                vErrors = [err14];
            }
            else {
                vErrors.push(err14);
            }
            errors++;
        }
        for (const key2 in data) {
            if (!((key2 === "status") || (key2 === "token"))) {
                const err15 = { instancePath, schemaPath: "#/oneOf/1/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.status !== undefined) {
            if ("tan required" !== data.status) {
                const err16 = { instancePath: instancePath + "/status", schemaPath: "#/oneOf/1/properties/status/const", keyword: "const", params: { allowedValue: "tan required" }, message: "must be equal to constant" };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.token !== undefined) {
            let data6 = data.token;
            if (typeof data6 === "string") {
                if (func2(data6) < 1) {
                    const err17 = { instancePath: instancePath + "/token", schemaPath: "#/oneOf/1/properties/token/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            else {
                const err18 = { instancePath: instancePath + "/token", schemaPath: "#/oneOf/1/properties/token/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
    }
    else {
        const err19 = { instancePath, schemaPath: "#/oneOf/1/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err19];
        }
        else {
            vErrors.push(err19);
        }
        errors++;
    }
    var _valid0 = _errs14 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid0) {
            valid0 = true;
            passing0 = 1;
        }
        const _errs20 = errors;
        if (data && typeof data == "object" && !Array.isArray(data)) {
            if (data.status === undefined) {
                const err20 = { instancePath, schemaPath: "#/oneOf/2/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                if (vErrors === null) {
                    vErrors = [err20];
                }
                else {
                    vErrors.push(err20);
                }
                errors++;
            }
            if (data.error === undefined) {
                const err21 = { instancePath, schemaPath: "#/oneOf/2/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property '" + "error" + "'" };
                if (vErrors === null) {
                    vErrors = [err21];
                }
                else {
                    vErrors.push(err21);
                }
                errors++;
            }
            for (const key3 in data) {
                if (!((key3 === "status") || (key3 === "error"))) {
                    const err22 = { instancePath, schemaPath: "#/oneOf/2/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
            }
            if (data.status !== undefined) {
                if ("error" !== data.status) {
                    const err23 = { instancePath: instancePath + "/status", schemaPath: "#/oneOf/2/properties/status/const", keyword: "const", params: { allowedValue: "error" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data.error !== undefined) {
                let data8 = data.error;
                if (typeof data8 !== "string") {
                    const err24 = { instancePath: instancePath + "/error", schemaPath: "#/oneOf/2/properties/error/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
                if (!((((data8 === "invalid credentials") || (data8 === "invalid tan")) || (data8 === "account locked")) || (data8 === "need verification"))) {
                    const err25 = { instancePath: instancePath + "/error", schemaPath: "#/oneOf/2/properties/error/enum", keyword: "enum", params: { allowedValues: schema13.oneOf[2].properties.error.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
        }
        else {
            const err26 = { instancePath, schemaPath: "#/oneOf/2/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err26];
            }
            else {
                vErrors.push(err26);
            }
            errors++;
        }
        var _valid0 = _errs20 === errors;
        if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 2];
        }
        else {
            if (_valid0) {
                valid0 = true;
                passing0 = 2;
            }
        }
    }
    if (!valid0) {
        const err27 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
        if (vErrors === null) {
            vErrors = [err27];
        }
        else {
            vErrors.push(err27);
        }
        errors++;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=AuthApi.generated.mjs.map